import { signalStore, withHooks, withState } from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { Colorset } from '../../models/colorset';
import { withColorsetSelectors } from './colorset.selectors';
import { ColorsetService } from '../../services/colorset/colorset.service';
import { withLogging } from '../features/logger.feature';

export type ColorsetState = BaseState<Colorset>;

export const initialState: ColorsetState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'ColorSet',
  entityLabel: 'Farbset',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const ColorsetStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Colorset>(ColorsetService),
  withLogging(initialState.entityType),
  withColorsetSelectors(),
  withHooks({
    onInit({ loadAllItemsByPromise }) {
      loadAllItemsByPromise();
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
